import { createFileRoute } from "@tanstack/react-router";
import { TourForm } from "@/components/admin/TourForm";
import { SiteHeader } from "@/components/site/SiteHeader";

export const Route = createFileRoute("/_authenticated/admin/tours/new")({
  head: () => ({
    meta: [
      { title: "Nuevo tour — Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
        <TourForm />
      </div>
    </div>
  ),
});
